import { atom } from "jotai";

type IInsightGenerationProgress =
    | "no_status"
    | "in_progress"
    | "successfull"
    | "failed";

type IArtifactType = "interview_note" | "transcript";

type ISinglensightGenerationProgress = Record<
    string,
    IInsightGenerationProgress
>;

type IAiInsightGenerationProgress = Record<
    IArtifactType,
    ISinglensightGenerationProgress
>;

export const INITIAL_INSIGHT_GENERATION_PROGRESS: IAiInsightGenerationProgress =
    {
        transcript: {},
        interview_note: {},
    };

export const aiInsightGenerationProgressAtom = atom(
    INITIAL_INSIGHT_GENERATION_PROGRESS
);

export const setAiInsightGenerationProgress = (
    setState,
    artifactType,
    interviewID: string,
    progressStatus: IInsightGenerationProgress,
    insightCount:number
) => {
    setState((state: IAiInsightGenerationProgress) => {
        const newState = { ...state };
        if (artifactType && interviewID) {
            newState[artifactType][interviewID] = progressStatus;
            newState[artifactType][`${interviewID}-insightCount`] = insightCount;
        }

        return newState;
    });
};

export const clearAiInsightGenerationProgress = (
    setState,
    artifactType,
    interviewID: string
) => {
    setState((state: IAiInsightGenerationProgress) => {
        const newState = { ...state };

        delete newState[artifactType][interviewID];
        delete newState[artifactType][`${interviewID}-insightCount`];

        return newState;
    });
};
